// LayoutAdmin.jsx
import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import NavBar from './NavBar'; // Adjust the import path as necessary
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import { useAuth } from '../../../AuthContext';
import axios from 'axios';

const LayoutAdmin = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(true);
  const [loading, setLoading] = useState(true);


  return (
    <div className="d-flex">
      {/* Pass expanded and setExpanded as props to NavBar */}
      <NavBar expanded={expanded} setExpanded={setExpanded} />
      <div
        className="flex-grow-1 bg-grey"
        style={{
          marginLeft: expanded ? 240 : 56, // Adjust margin based on expanded state
          transition: 'margin-left 0.3s ease', // Smooth transition for margin
        }}
      >
    
    {/* Outlet to render child routes */}
        <div className="main-content">
        <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LayoutAdmin;
